import { TextBox, TextBoxLayoutStyle } from '@apply/components';
import { useStandardLoanStore } from '../../../../../../state/standardLoanStore';
import { isRequiredOnceNoteDated } from '../functions/isRequiredOnceNoteDated';

/** Upper-case letters and digits only, up to 9 characters. */
export const BfiNumberField = () => {
    /** BFI #: upper-case letters and digits only, up to 9 characters (same cleaning as the existing BfiNumber input). */
    const cleanBfiNumber = (input: string | undefined) => (input ?? '').toUpperCase().replace(/[^0-9A-Z]/g, '');

    const setup = useStandardLoanStore((state) => state.setup);
    const updateSetup = useStandardLoanStore((state) => state.updateSetup);

    return (
        <TextBox
            id='setupBfiNumber'
            value={setup.bfiNumber}
            onChange={(bfiNumber) => updateSetup({ bfiNumber: cleanBfiNumber(bfiNumber) })}
            label='BFI #'
            required={isRequiredOnceNoteDated(setup)}
            maxLength={9}
            width='100%'
            height='36px'
            layoutStyle={TextBoxLayoutStyle.Horizontal}
            labelWidth='100px'
        />
    );
};
